
import referral from './referral.json';
import content from './content.json';
import following from './following.json';

export default {
  description: "Connectez-vous avec la communauté et partagez vos expériences",
  referral,
  content,
  following
};
